/** Error 정의  */
export const QUERY_ERROR_KEY = {
  KEY_TEST: 'KEY_TEST',
} as const;

//# 500 Error
const queryErrorHandler = (err: any): void => {
  if (err) {
    switch (err.response?.data.code) {
      case QUERY_ERROR_KEY.KEY_TEST:
        alert('더미 예시');
        break;
    }
  } else {
    alert(err);
  }
};

export default queryErrorHandler;
